import PostsList from "./components/PostsList";
import ReactQuillComp from "./components/ReactQuillComp";

function App() {
  return (
    <div>
      <ReactQuillComp/>
      {/* <PostsList /> */}
    </div>
  );
}

export default App;
